<template>
    <div>
        <my-header></my-header>
        <div class="container">
            <img src="../../assets/img/home_bg.png" alt="" class="top">
            <div class="df content">
                <div class="df info">
                    <img :src="userInfo.Avatar" alt="">
                    <p>No.{{userInfo.JobNo}}</p>
                    <p class="ft20">{{userInfo.NickName}}</p>
                </div>
                <h3 class="title">账号设置</h3>
            </div>
            <div class="setting-box">
                <ul class="setting-list">
                    <li class="item">
                        <div class="fl item-title">账号名：</div>
                        <div class="fl">No.{{userInfo.JobNo}}</div>
                    </li>
                    <li class="item">
                        <div class="fl item-title">昵　称：</div>
                        <div class="fl">{{userInfo.NickName}}</div>
                        <div class="fr item-btn" @click="openDialog(1)">修改昵称</div>
                    </li>
                    <li class="item">
                        <div class="fl item-title">头　像：</div>
                        <img :src="userInfo.Avatar" alt="" class="fl item-img">
                        <div class="fr item-btn" @click="openDialog(2)">修改头像</div>
                    </li>
                    <!-- <li class="item">
                        <div class="fl item-title">密　码：</div>
                        <div class="fl">{{userInfo.Pwd | encrypt}}</div>
                        <div class="fr item-btn" @click="openDialog(3)">修改密码</div>
                    </li> -->
                </ul>
            </div>
            <div class="dialog" v-show="isDialogShow">
                <div class="model">
                    <h3 class="mo-title">{{dialogTitle}}<span class="mo-close" @click="closeDialog">×</span></h3>
                    <div class="mo-content">
                        <div v-show="type==1">
                            <div class="mo-item">
                                昵称　<input type="text" v-model="nickName" id="">
                                <span class="warn" v-show="isVerify && nickName.length==0">昵称不能为空</span>
                            </div>
                        </div>
                        <div v-if="type==2">
                            <change-avatar :isGetResult="isGetResult" @getAvatar="saveAvatar"></change-avatar>
                        </div>
                        <div v-show="type==3">
                            <form>
                                <div class="mo-item">
                                    当前密码
                                    <div class="input-box">
                                        <input type="password" class="password" v-model="nowPwd" placeholder="请输入当前密码" @change="focusInput($event)">
                                        <input type="text" class="show-text" v-show="isNowPwdShow" v-model="nowPwd" placeholder="请输入当前密码">
                                        <div class="view-icon" @click="changeViewStatus($event,1)"><img :src="!isNowPwdShow ? showIcon : hideIcon" alt=""></div>
                                    </div>
                                    <span class="warn" v-show="isVerify && nowPwd.length==0">密码不能为空&nbsp;&nbsp;</span>
                                    <span class="warn" v-show="isVerify && nowPwd.length>0">√</span>
                                </div>
                                <div class="mo-item">
                                    &nbsp;&nbsp;新密码
                                    <div class="input-box">
                                        <input type="password" class="password" v-model="newPwd" placeholder="请输入6-16位的密码" maxlength="16"  @change="focusInput($event)">
                                        <input type="text" class="show-text" v-show="isNewPwdShow" v-model="newPwd" placeholder="请输入6-16位的密码" maxlength="16">
                                        <div class="view-icon" @click="changeViewStatus($event,2)"><img :src="!isNewPwdShow ? showIcon : hideIcon" alt=""></div>
                                    </div>
                                    <span class="warn" v-show="isVerify && newPwd.length<6 && newPwd.length>0">密码长度太短</span>
                                    <span class="warn" v-show="isVerify && newPwd.length>=6">√</span>
                                    <span class="warn" v-show="isVerify && newPwd.length==0">密码不能为空</span>
                                </div>
                                <div class="mo-item">
                                    确认密码
                                    <div class="input-box">
                                        <input type="password" class="password" v-model="confirmPwd" placeholder="请再输入一遍密码" maxlength="16" @change="focusInput($event)">
                                        <input type="text" class="show-text" v-show="isConfirmPwdShow" v-model="confirmPwd" placeholder="请再输入一遍密码" maxlength="16">
                                        <div class="view-icon" @click="changeViewStatus($event,3)"><img :src="!isConfirmPwdShow ? showIcon : hideIcon" alt=""></div>
                                    </div>
                                    <span class="warn" v-show="isVerify && confirmPwd!=newPwd">密码不一致</span>
                                    <span class="warn" v-show="isVerify && confirmPwd==newPwd && newPwd.length>0">√</span>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="df mo-handel">
                        <div class="mo-btn btn-sure" @click="verifyResult">保存</div>
                        <div class="mo-btn btn-cancel" @click="closeDialog">取消</div>
                    </div>
                </div>
            </div>
            <Warn ref="warn"></Warn>
        </div>
        <my-footer></my-footer>
    </div>
</template>
<script>
import {encrypt} from "../../assets/js/modules/utils"
import changeAvatar from "./changeavatar"
import Warn from "../common/warn"
import {updateAvatar,updateNickName,updatePassword} from "@/assets/js/modules/userApi"
import {Base64} from 'js-base64'
import showIcon from "@/assets/img/show_icon.png"
import hideIcon from "@/assets/img/hide_icon.png"
export default {
  inject: ['reload'],
  components: {
    changeAvatar,
    Warn,
  },
  data(){
      return {
          userInfo: {
              Id: "",
              Avatar: "",   //头像
              JobNo: "182904",    //工号
              Name: "王某",     //姓名
              NickName: "王某", //昵称
              ProductList: [],      //作品列表
              CollectList: [],      //收藏列表
          },
          type: 2,         //弹框类型   1--昵称, 2--头像, 3--密码
          dialogTitle: "",        //弹框标题
          nickName: "",     //昵称
          nowPwd: "",      //当前密码
          newPwd: "",       //新密码
          confirmPwd: "",   //确认密码
          isNowPwdShow: false,
          isNewPwdShow: false,
          isConfirmPwdShow: false,
          isVerify: false,  //是否验证过
          isGetResult: false,   //是否获取头像修改结果
          isDialogShow: false,  //是否出现弹窗
          showIcon: showIcon,
          hideIcon: hideIcon,
      }
  },
  mounted(){
    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    Object.keys(this.userInfo).forEach((key)=>{
        if(userInfo.hasOwnProperty(key)){
            this.userInfo[key] = userInfo[key];
        }
    });
    this.userInfo.Pwd = Base64.decode(localStorage.getItem(Base64.encode('password')));
    this.nickName = this.userInfo.NickName;
  },
  filters: {
      encrypt(str){
          return "******";
      }
  },
  methods: {
      //验证并保存数据
      verifyResult(){
        this.isVerify = true;
        switch(this.type){
            case 1:
                this.saveNick();
                break;
            case 2: 
                this.isGetResult = true;
                break;
            case 3:
                this.savePwd();
                break;
        }
      },
      //保存昵称
      saveNick(){
        var that = this;
        if(this.nickName.length==0) return;
        //修改昵称,保存至服务器
        let data = {
            Id: this.userInfo.Id,
            NickName: this.nickName
        };
        updateNickName(data).then(res=>{
            if(res.data.Success){
                let info = JSON.parse(localStorage.getItem('userInfo'));
                info.NickName = this.userInfo.NickName = this.nickName;
                localStorage.setItem('userInfo',JSON.stringify(info));
                //关闭弹窗
                this.isDialogShow = false;
                this.isVerify = false;
                //保存成功,弹出提示
                this.$refs.warn.message("昵称修改成功!");
            }
        })
        
      },
      //保存头像
      saveAvatar(data){
        var that = this;
        if(!data.url) return;
        this.isGetResult = false;
        this.$refs.warn.message("保存中...");
        //上传头像至服务器
        let newData = {
            Id: this.userInfo.Id,
            FileContent: data.url,
            FileExtension: "png"
        };
        updateAvatar(newData).then((res)=>{
            if(res.data.Success){
                let info = JSON.parse(localStorage.getItem('userInfo'));
                info.Avatar = this.userInfo.Avatar = data.url;
                localStorage.setItem('userInfo',JSON.stringify(info));
                this.reload();
            }
        })
      },
      //保存密码
      savePwd(){
        var that = this;
        if(this.nowPwd.length==0) return;
        if(this.newPwd.length<6) return;
        if(this.newPwd!=this.confirmPwd) return;
        //修改密码,保存至服务器
        let data = {
            OldPwd: Base64.encode(this.nowPwd),
            NewPwd: Base64.encode(this.newPwd),
            Id: this.userInfo.Id
        };
        updatePassword(data).then(res=>{
            if(res.data.Success){
                localStorage.setItem(Base64.encode('password'),Base64.encode(that.newPwd));
                //关闭弹窗
                this.isDialogShow = false;
                this.isVerify = false;
                //保存成功,弹出提示
                this.$refs.warn.message("密码修改成功!");
                that.nowPwd = that.newPwd = that.confirmPwd = "";
            }
        })
        
      },
      //点击弹窗
      openDialog(index){
          this.isDialogShow = true;
          switch(index){
            case 1: 
                this.dialogTitle = "修改昵称";
                this.type = 1;
                break;
            case 2:
                this.dialogTitle = "修改头像";
                this.type = 2;
                break;
            case 3:
                this.dialogTitle = "修改密码";
                this.type = 3;
                break;
          }
      },
      //关闭弹窗
      closeDialog(){
          this.isDialogShow = false;
          this.isVerify = false;
      },
      //关闭提示框
      closeWarn(data){
        this.$refs.warn.closeWarn();
      },
      //改变查看状态
      changeViewStatus(el,index){
          let flag = false;
          switch(index){
              case 1:
                this.isNowPwdShow = !this.isNowPwdShow;
                flag = this.isNowPwdShow;
                break;
              case 2:
                this.isNewPwdShow = !this.isNewPwdShow;
                flag = this.isNewPwdShow;
                break;
              case 3:
                this.isConfirmPwdShow = !this.isConfirmPwdShow;
                flag = this.isConfirmPwdShow;
                break;
          }
          setTimeout(()=>{
            if(flag){
              el.target.parentNode.parentNode.querySelector('.show-text').focus();
            }else{
                el.target.parentNode.parentNode.querySelector('.password').focus();              
            }
          },10);
      },
      focusInput(el){
          let element = el.target;
          element.nextElementSibling.focus();
      }
  },
  watch: {
      nowPwd(){
          this.nowPwd = this.nowPwd.replace(/([\u4E00-\u9FA5])|(\s*)/g,'');
      },
      newPwd(){
          this.newPwd = this.newPwd.replace(/([\u4E00-\u9FA5])|(\s*)/g,'');
          this
      },
      confirmPwd(){
          this.confirmPwd = this.confirmPwd.replace(/([\u4E00-\u9FA5])|(\s*)/g,'');
      }
  }
}
</script>
<style scoped>
.top{
    display: block;
    width: 100%;
}
.content{
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    background-color: #fff;
}
.info{
    flex-direction: column;
    justify-content: flex-start;
    padding-bottom: 30px;
}
.info img{
    width: 135px;
    height: 135px;
    background-color: #e7e7e7;
    border: 6px solid #fff;
    border-radius: 50%;
    margin-top: -50%;
}
.info p{
    margin-top: 10px;
}
.ft20{
    font-size: 20px;
}
.content .title{
    width: 100%;
    font-size: 18px;
    color: #333;
    height: 80px;
    line-height: 80px;
    border-top: 1px solid #e7e7e7;
    border-bottom: 1px solid #e7e7e7;
}
.setting-box{
    max-width: 1280px;
    margin: 20px auto;
    border: 1px solid #e7e7e7;
    border-radius: 10px;
    background-color: #fff;
    padding-bottom: 300px;
}
.setting-list{
    margin: 0 52px;
    line-height: 90px;
}
.item{
    overflow: auto;
    height: 90px;
    padding: 0 20px 0 6px;
    border-bottom: 1px solid #e7e7e7;
}
.item-title{
    width: 100px;
}
.item-img{
    display: block;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    margin-top: 21px;
    background-color: #e7e7e7;
}
.item-btn{
    width: 100px;
    text-align: center;
    height: 30px;
    line-height: 30px;
    margin-top: 30px;
    border: 1px solid #ff9933;
    border-radius: 15px;
    font-size: 14px;
    color: #999;
    cursor: pointer;
}
.item-btn:hover{
    background-color: #ff9933;
    color: #fff;
}
.dialog{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.2);
    z-index: 99;
}
.model{
    position: absolute;
    top: 50%;
    left: 50%;
    width: 620px;
    padding-bottom: 40px;
    transform: translate(-50%,-50%);
    background-color: #fff;
    border-radius: 10px;
}
.mo-title{
    line-height: 80px;
    height: 80px;
    font-size: 18px;
    color: #333;
    text-align: center;
    position: relative;
    border-bottom: 1px solid #e7e7e7;
}
.mo-close{
    position: absolute;
    right: 10px;
    top: 10px;
    font-size: 40px;
    line-height: 1;
    color: #999;
    cursor: pointer;
}
.mo-close:hover{
    color: #666;
}
.mo-content{
    padding: 40px 0;
}
.mo-item{
    display: flex;
    justify-content: center;
    font-size: 14px;
    line-height: 40px;
    margin-bottom: 15px;
    position: relative;
}
.mo-item input,.mo-item .input-box{
    line-height: 38px;
    height: 40px;
    width: 380px;
}
.mo-item input, .input-box .show-text{
    padding-left: 15px;
    border: 1px solid #e7e7e7;
    background-color: #f8f8f8;
    border-radius: 5px;
    color: #666;
    padding-right: 32px;
    box-sizing: border-box;
}
.mo-item .input-box{
    margin-left: 10px;
    position: relative;
}
.input-box .show-text{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.input-box .view-icon{
    position: absolute;
    right: 10px;
    width: 22px;
    top: 0;
    height: 100%;
    cursor: pointer;
    z-index: 5;
}
.view-icon img{
    margin-top: 14px;
}
.mo-item .warn{
    position: absolute;
    right: 3px;
    color: #ff6633;
    display: block;
    width: 85px;
    text-align: center;
}
.mo-handel{
    justify-content: center;
    text-align: center;
}
.mo-btn{
    width: 150px;
    height: 40px;
    line-height: 38px;
    border-radius: 20px;
    box-sizing: border-box;
    border: 1px solid #ff9933;
    cursor: pointer;
}
.btn-sure{
    background-color: #ff9933;
    color: #fff;
    margin-right: 30px;
}
.btn-sure:hover{
    background-color: #ff8833;
}
.btn-cancel{
    color: #999;
}
.btn-cancel:hover{
    background-color: #fbfbfb;
}
</style>



// WEBPACK FOOTER //
// src/components/accountsetting/index.vue